<template>
  <v-card outlined>
    <v-row class="align-center d-flex justify-space-between">
      <v-col cols="auto">
        <v-card-title style="font-size: 20px">{{ filterTitle }}</v-card-title>
      </v-col>
      <v-col cols="auto">
        <v-btn
          icon
          variant="text"
          size="small"
          :aria-label="esconderFiltros ? 'Expandir filtros' : 'Recolher filtros'"
          @click="esconderFiltros = !esconderFiltros"
        >
          <v-icon>
            {{ esconderFiltros ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-expand-transition>
      <div v-show="!esconderFiltros" class="pt-0">
        <filtros-dinamicos
          ref="filtrosDinamicos"
          class="mt-0"
          :filtersProp="filtersProp"
          :service="service"
          :loadingProp="loadingProp"
          :serviceMethod="serviceMethod"
          :with-border="false"
          :filterSlotProp="filterSlotProp"
          :buttonDependencies="buttonDependencies"
          :inlineFilterCols="inlineFilterCols"
          filterTitle=""
          @applyFilters="$emit('applyFilters', $event)"
          @resetFilters="$emit('resetFilters')"
        >
          <template #before-filters="{ updateDynamicFilter }">
            <slot name="before-filters" :updateDynamicFilter="updateDynamicFilter"></slot>
          </template>

          <template #inline-filter>
            <slot name="inline-filter"></slot>
          </template>

          <template #after-filters="{ updateDynamicFilter }">
            <slot name="after-filters" :updateDynamicFilter="updateDynamicFilter"></slot>
          </template>
        </filtros-dinamicos>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
  import FiltrosDinamicos from '@/components/general/filtros/FiltrosDinamicos';

  export default {
    name: 'DashboardFiltrosCollapse',

    components: {
      FiltrosDinamicos
    },

    props: {
      filtersProp: {
        type: Object,
        required: true
      },
      filterSlotProp: {
        type: Object,
        default: () => ({})
      },
      service: {
        type: Object,
        required: true
      },
      loadingProp: {
        type: Boolean,
        default: false
      },
      filterTitle: {
        type: String,
        default: 'Filtros'
      },
      serviceMethod: {
        type: String,
        required: true
      },
      buttonDependencies: {
        type: Array,
        default: () => []
      },
      inlineFilterCols: {
        type: Object,
        default: () => ({})
      }
    },

    data() {
      return {
        esconderFiltros: false
      };
    },

    methods: {
      atualizarFiltros() {
        return this.$refs.filtrosDinamicos ? this.$refs.filtrosDinamicos.fetchFilters() : Promise.resolve();
      }
    }
  };
</script>
